const ASSET_BASE_PATH = (
  process.env.NEXT_PUBLIC_OD_ASSET_BASE_PATH ?? ''
).replace(/\/+$/, '');

export function paulAssetPath(path: `/${string}`): string {
  return `${ASSET_BASE_PATH}${path}`;
}
